import { SidebarHeader } from "@/components/layout/SidebarHeader";
import { useCurrentWorkflow } from "@/hooks/useCurrentWorkflow";
import { ShareButton } from "@/components/flow/deploy/ShareButton";
import { DelayedTooltip } from "@scripts/react/components/DelayedTooltip";

export function ShareSidebarContent() {
    const { currentWorkflow: workflow } = useCurrentWorkflow();

    return (
        <>
            <SidebarHeader title="Test Model" />
            <div className="flex flex-col gap-4 p-4">
                {workflow?.name && (
                    <div className="mb-2 min-w-0">
                        <DelayedTooltip content={workflow.name} className="text-lg font-semibold" />
                    </div>
                )}
                <p className="text-sm text-tertiary">
                    Test this model by uploading images or videos. Anyone with this link can test
                    the model without signing in.
                </p>
                <div className="rounded-lg bg-gray-50 p-3">
                    <p className="mb-2 text-xs text-tertiary">
                        <i className="far fa-info-circle mr-1" />
                        Upload files to test the model's performance
                    </p>
                </div>
                <ShareButton />
            </div>
        </>
    );
}
